module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37ad8c1d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/login.vue
// module id = 910
// module chunks = 1